import {Component, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-filter-popup',
  templateUrl: './filter-popup.component.pug',
  styleUrls: ['./filter-popup.component.scss'],
  standalone: false
})
export class FilterPopupComponent implements OnInit {
  @Output() applyFilter = new EventEmitter();
  @ViewChild('dateFilter', {static: false}) filterDropdown: any;
  toggleMapping = new Map();
  roles = ["Owner", "Administrator", "Requestor", "Contributor", "Analyst", "Xref Support"]
  filterCount = 0
  filterEnabled = false

  @HostListener('document:click', ['$event'])
  clickout(event) {
  }

  constructor() {
  }

  ngOnInit(): void {

  }

  toggleRole(role: string) {
    const isRoleToggled = this.toggleMapping.get(role) || false;
    if (isRoleToggled) {
      this.toggleMapping.set(role, false);
    } else {
      this.toggleMapping.set(role, true);
    }
  }

  applyFilters() {
    this.filterCount = 0;
    this.filterEnabled = false;
    this.applyFilter.emit(this.toggleMapping);
    this.filterDropdown.hide();
    this.toggleMapping.forEach((value, key) => {
      if (value === true) {
        this.filterCount++;
        this.filterEnabled = true;
      }
    });
  }

  resetFilters() {
    this.toggleMapping.clear()
    this.applyFilter.emit(this.toggleMapping);
    this.filterDropdown.hide();
    this.filterCount = 0;
    this.filterEnabled = false;
  }

  hideModal() {
    this.filterDropdown.hide();
  }
}
